export enum localStorageName {
    mapCenterExpiration = "mapCenterExpiration",
    mapCenterLastModified = "mapCenterLastModified",
    mapCenterStoredCoordinates = "mapCenterStoredCoordinates",
    currentTripDraft = "currentTripDraft",
}
